<template>
    <el-button :type="buttonType"
        @click="onClick"
        :title="buttonTitle">{{dataButtonText}}</el-button>
</template>

<script>
export default {
    name : 'SubmitTicketButton',

    props : ['buttonText'],

    data () {
        return {
            disabled : false,
            buttonType : "primary",
            dataButtonText : "提交工单",
            buttonTitle : "点我提交工单"
        }
    },

    watch : {
        buttonText() {
            this.dataButtonText = this.buttonText;
        }
    },

    mounted() {
        this.dataButtonText = this.buttonText || this.dataButtonText;
    },

    methods: {
        loadDefault() {
            this.buttonType = "primary";
            this.dataButtonText = this.buttonText || "提交工单";
            this.buttonTitle = "点我提交";
        },

        onClick(e) {
            if ( this.disabled ) {
                console.log('#41 onClick disabled', this.disabled);
                return;
            }

            this.$emit('click', e);
        },

        enable() {
            this.disabled = false;

            this.loadDefault();
        },

        disable() {
            this.disabled = true;

            this.buttonType = "info";
            this.dataButtonText = "正在提交";
            this.buttonTitle = "正在提交,请稍后;如果长时间未恢复,可尝试刷新页面";
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/SubmitTicketButton.vue